<template>
  <van-pull-refresh v-model="isDownLoading" @refresh="onDownRefresh" :pulling-text="$t('message.pullingText')"
  :loosing-text="$t('message.loosingText')" :loading-text="$t('message.Loading')">
    <div style="min-height: calc(100vh - 30px)">
      <van-list
          v-model="isUpLoading"
          :finished="upFinished"
          :finished-text="$t('message.Nothing')"
          :immediate-check="false"
          :offset="100"
          @load="onLoad"
      >
        <div class="wrap" v-if="list.length>0">
          <van-row :gutter="20">
            <van-col :span="12" v-for="(item, x) in list" :key="x" class="box-content">
              <div class="box" v-if="item.Module.length ==2"
                   :style="{ 'background-image': 'url(' + imgUrl + ')',  }">
                <h2 style="margin-bottom: 20px;">
                  {{ item.Remark }}
                </h2>
                <div style="padding:16px 0 0 16px">
                  <van-row :gutter="0">
                    <van-col :span="12" v-for="(item1, y) in item.Module" :key="y">
                      <div class="content2" :style="{'margin-right':'16px'}" @click="goUrl2(item1,item)">
                        <h1>{{ item1.Total }}</h1>
                        <p>{{ item1.Remark }}</p>
                      </div>
                    </van-col>
                  </van-row>
                </div>
              </div>
              <div class="box" v-else style="position: relative;" @click="goUrl(item)">
                <h2>{{ item.Remark }}</h2>
                <p>
                  {{ $t('message.Todo_Total') }}<span>{{ item.Total }}</span>{{ $t('message.Todo_Tasks') }}
                </p>
              </div>
            </van-col>
          </van-row>
        </div>
        <div v-else class="empty-tip">
          <van-empty :description="$t('message.Nothing')" />
        </div>
      </van-list>
    </div>
  </van-pull-refresh>
</template>

<script>
import ApiUrls from "@/api/apiUrls";
import axios from "axios";
import eruda from 'eruda';
export default {
  name:'TODO',
  components: {},

  data() {
    return {
      list: [],
      imgUrl:'',
      listBank:[],
      pageindex:1,
      pagesize:10,
      isDownLoading: false, // 下拉刷新
      isUpLoading: false, // 上拉加载
      upFinished: false, // 上拉加载完毕
      offset: 100,// 滚动条与底部距离小于 offset 时触发load事件
      UserId: localStorage.getItem('UserId'),
      language:'zh-cn',
    };
  },
  computed: {
  },
  beforeCreate() {
  },
  async created() {
    if(process.env.NODE_ENV == 'production'){
      let response = await axios.get(ApiUrls.baseUrl+'/AppConfig/fyuserid.json?Version=2');
      console.log(response,'response');
      let isShowConsole = response.data.filter(x=>x.toLowerCase()==this.UserId).length>0
      if(isShowConsole){
        eruda.init();
      }
    }  

    if (this.$browserType() > 4 && process.env.NODE_ENV === 'production') {
      cs.getUserInfo((result) => {
        // alert(result)
        console.log(result,"result");
        if (result.state == 1) {
          var data = result.result;
          this.language=data.Language
          console.log(this.$getSystemLanguage(),"系统语言");
          console.log(data.Language,"APP返回语言");
          
          this.setLanguage(data.Language)
          window.localStorage.setItem('token',result.access_token)
          window.localStorage.setItem('UserId',data.Id)
          this.fetchData()
        }
      });
      return
    }
    this.fetchData()
  },
  mounted() {
    this.fetchData()
  },
  methods: {
    setLanguage(lang){
      if (lang == 'en-us') {
          this.$i18n.locale = 'en-GB';
      } else {
          this.$i18n.locale = 'zh-cn';
      }
      console.log(this.$i18n.locale,"i18n语言");
    },
    getQueryVariable(url,name) {
      var reg = new RegExp("(^|\\?|&)"+ name +"=([^&]*)(\\s|&|$)", "i");
      if (reg.test(url)) {
        return unescape(RegExp.$2.replace(/\+/g, " "));
      }else{
        return "";
      }
    },
    onDownRefresh(){
      this.fetchData()
    },
    getToken(row){
      cs.getUserInfo((result) => {
        console.log(result,"获取最新的用户信息");
        if (result.state == 1) {
          var data = result.result;
          window.localStorage.setItem('token',result.access_token)
          window.localStorage.setItem('UserId',data.Id)
          this.goUrl(row)
        }
      });
    },
    goUrl2(row,flag){
      if (row.isHide) return
      
      this.$reqPost(ApiUrls.APPMANAGE_SAVEMODULEVISITLOG, {
        UserId:localStorage.getItem('UserId'),
        SystemId:flag.App.Id,
      }).then(res => {
      })
      debugger
      if (row.TodoUrl){
        cs.openWebView(row.TodoUrl)
        return
      }      
    },
    goUrl(row,flag){
      console.log(row,"row");
      if (row.isHide) return
      
      this.$reqPost(ApiUrls.APPMANAGE_SAVEMODULEVISITLOG, {
        UserId:localStorage.getItem('UserId'),
        SystemId:row.App.Id,
      }).then(res => {
      })
      
      if (row.TodoUrl){
        cs.openWebView(row.TodoUrl)
        return
      }      
    },
    
    onLoad(){},
    //初始化获取接口
    async fetchData() {
      const _self = this
      let toast1 = this.$toast.loading({message: '', forbidClick: true, duration: 0});
      this.$reqPost(ApiUrls.USER_GETUSERTODO, {
        UserId:localStorage.getItem('UserId'),
        // cultureCode:'en-us',
        cultureCode:this.language,
      }).then(res => {
        _self.isDownLoading = false
        toast1.close()
        _self.list = res
      }).catch(()=>{
        _self.isDownLoading = false
      })
    },
  },
};
</script>

<style scoped>
.wrap {
  /* background: #aac9fb; */
  padding: 0 16px 16px 16px;
  /* height: 100vh; */
  background-size: contain;
}

.box {
  border-radius: 12px;
  background: #fff;
  margin: 16px 0 0;
  padding: 16px 0;
  height: 130px;
  background-size: contain;
  background-position: center bottom;
  background-repeat: no-repeat;
}

/* .box-content:first-child .box{height:248px;background:#fff url("../assets/images/todo-bg-01.png") no-repeat center bottom;    background-size: contain;} */
.box-content:nth-child(1) .box {
  /* background: #fff url("../assets/images/todo-bg-02.png") no-repeat right bottom; */
  background-size: contain;
}

.box-content:nth-child(2) .box {
  /* background: #fff url("../assets/images/todo-bg-03.png") no-repeat right bottom; */
  background-size: contain;
}

.box span {
  color: #0063be;
  margin: 0 10px;font-size: 16px;
  font-weight: 600;
}

.box p {
  font-size: 14px;
  margin: 0 0 0 16px
}
.box h2 {
  margin: 0 0 16px 0;
  font-size: 18px;
  font-weight: 600;
  position: relative;
  padding: 0 0 0 16px;
}

.box h2::before {
  content: "";
  width: 4px;
  height: 20px;
  background-color: #0064be;
  position: absolute;
  top: 3px;
  left: 0;
}

.box h2 img {
  width: 22px;
  margin-left: 10px;
  vertical-align: bottom;
}
.content2 {
  text-align: center;
  margin: 0;
  background: #eaf1fd;
  border-radius: 12px;
  padding: 10px 0
}
.content2 h1{font-size: 16px;margin:0;padding:0;font-weight: 600;}

.content2 p {
  font-size: 12px;
  margin: 10px 0 0 0;
}
.empty-tip {
  display: flex;
  justify-content: center;
  align-items: center;
  min-height: 300px;
}
</style>
